import { Page } from '@/core/architecture'

import { ResaleApplicationCreatePrecautionTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ResaleApplication Page
 * Implemented as a practical sample.
 */
export const ResaleApplicationCreatePrecaution: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <ResaleApplicationCreatePrecautionTemplate state={state} {...actions} />
  )
}
